import React from 'react'

// Constants
import { HEADER_MENU_TITLE_LINK } from '../../constants'

// Helper Functions
import { formatUrl } from '../../helperFunctions'

export const SERVCIES = [
  {
    head: HEADER_MENU_TITLE_LINK.services.integration,
    bg: 'bg-ser-6',
    scrollId: formatUrl(HEADER_MENU_TITLE_LINK.services.integration),
    content: <React.Fragment>
      <p>EIDIM provides the most effective way of installing &amp; integrating the system according to the characteristics of the building and the individual service style. We take into consideration how the system will be used, who will use it, and the environment in which it must perform.</p>
      <p>EIDIM provides on-site supervision and direction to ensure that the integrity of the customer is preserved by maintaining regular communication and coordination with project architects, consultants, designers.</p>
      <p>We can build any custom pieces required to complete any installation. We have developed certified professionals of audiovisual system installation and integration who are able to implement solutions and overcome challenges.</p>
    </React.Fragment>
  },

  {
    head: HEADER_MENU_TITLE_LINK.services.design,
    bg: 'bg-ser-3',
    order: 'flip',
    scrollId: formatUrl(HEADER_MENU_TITLE_LINK.services.design),
    content: <React.Fragment>
      <p>EIDIM Group, Inc. provides both professionals and end users with cost effective, well-designed Audio-Visual systems for both bid and design build projects.</p>
      <p>Our A/V engineering facilities are first class, utilizing the latest state-of-the-art computer aided design software and hardware to ensure accurate final results.</p>
    </React.Fragment>
  },

  {
    head: HEADER_MENU_TITLE_LINK.services.consultation,
    bg: 'bg-ser-4',
    scrollId: formatUrl(HEADER_MENU_TITLE_LINK.services.consultation),
    content: <React.Fragment>
      <p>EIDIM provides expert advices and consultations for proper audiovisual systems. Our staffs hold several professional degrees and affiliations. Consultation begins with comprehensive needs analysis.</p>
      <p>With decades of industry knowledge and experience, we work closely with our customer to create affordable audiovisual system solutions that will satisfy their needs, objectives, expectations and budget.</p>
      <p>To completely understand customer’s expectation, EIDIM will discuss your audiovisual needs and objectives then investigate the structure of the building and thoroughly research the latest technologies and products. Those efforts allow us to conceptualize an appropriate solution.</p>
    </React.Fragment>
  },

  {
    head: HEADER_MENU_TITLE_LINK.services.trainingMaintenance,
    bg: 'bg-ser-9',
    order: 'flip',
    scrollId: formatUrl(HEADER_MENU_TITLE_LINK.services.trainingMaintenance),
    content: <React.Fragment>
      <p>EIDIM offers extensive training after completion of installation. Our training program ranges from how to use the equipment to understanding of why and when use it.</p>
      <p>We also provide customizable and comprehensive maintenance service with the qualified technician. It covers the most components of the installation to ensure audiovisual system operation and permanence at optimum level.</p>
      <p>Our maintenance service varies from troubleshooting and part changes to upgrading equipment and software.</p>
    </React.Fragment>
  },

  {
    head: HEADER_MENU_TITLE_LINK.services.avEngineering,
    bg: 'bg-ser-1',
    scrollId: formatUrl(HEADER_MENU_TITLE_LINK.services.avEngineering),
    content: <React.Fragment>
      <p>EIDIM meets with the customer to develop a customer-centric approach for the desired audiovisual systems by identifying their needs.</p>
      <p>We are focused and driven by customer’s goals to deliver innovative solutions that incorporate their business considerations.</p>
      <p>Our engineering facilities are first class, utilizing the latest state-of-the-art computer-aided design software and hardware to ensure accurate final results.</p>
    </React.Fragment>
  },

  {
    head: HEADER_MENU_TITLE_LINK.services.avProgramming,
    bg: 'bg-ser-2',
    order: 'flip',
    scrollId: formatUrl(HEADER_MENU_TITLE_LINK.services.avProgramming),
    content: <React.Fragment>
      <p>EIDIM strives to have make and provide the most updated technology not just on hardware but also to software needs of you AV system. We cater control system programming that would best fit to the system whether it’s existing, upgrades, new installs.</p>
      <p>As a result, we aim to have the best experience of control system and software development that will address your AV needs.</p>
    </React.Fragment>
  },

  {
    head: HEADER_MENU_TITLE_LINK.services.procurement,
    bg: 'bg-ser-7',
    scrollId: formatUrl(HEADER_MENU_TITLE_LINK.services.procurement),
    content: <React.Fragment>
      <p>EIDIM carries hundreds of AV Brands that are accessible. We can do procurements services internationally.</p>
      <ul style={{ margin: '1rem 0' }}>
        <li>Blanket Purchases</li>
        <li>GSA Schedule</li>
      </ul>
    </React.Fragment>
  },

  {
    head: HEADER_MENU_TITLE_LINK.services.remoteManagement,
    bg: 'bg-ser-8',
    order: 'flip',
    scrollId: formatUrl(HEADER_MENU_TITLE_LINK.services.remoteManagement),
    content: <React.Fragment>
      <p>No more wait times for on-site technicians to visit the site when it can be done in distance. EIDIM offers remote monitoring services for your AV system and other system connected to it.</p>
      <p>Preventing system issues ahead of time and efficiently fix without any hassle. Making on-site service repairs/installation process convenient, faster, and easier when this service is done beforehand.</p>
    </React.Fragment>
  },
]